export const validationSizes = {
  string: {
    short: 100,
    middle: 250,
    long: 500,
  },
} as const
